var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-person-info"},[_c('div',{staticClass:"person-item",on:{"click":_vm.on_open_modal}},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.avatar}})]),_c('div',{staticClass:"name-info"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('p',{staticClass:"age-inter"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }